
 import React from "react";
import "./CorporatePageElementsCss/CorporateReportStatus.css";
import { FaTimes } from "react-icons/fa";

const CorporateReportStatusModal = ({ open, onClose,  reportList  }) => {
  if (!open) return null;

  const formatDate = (d) => {
    if (!d) return "-";
    // try ISO string or already formatted
    try {
      const dt = new Date(d);
      if (!isNaN(dt)) {
        return dt.toLocaleDateString();
      }
    } catch (e) {}
    return String(d);
  };

  const name  = reportList && reportList.length > 0 ? (reportList[0].Name|| "-") : "-";
  const BillId = reportList && reportList.length > 0 ? (reportList[0].AccNo|| "-") : "-";
  const date = reportList && reportList.length > 0 ? (reportList[0].BookingDate|| "-") : "-";

  return (
    <div className="status-modal-overlay" role="dialog" aria-modal="true">
      <div className="status-modal" role="document">
        <div className="status-modal-header">
          <h2 className="status-title">Report Status</h2>
          <button className="close-btn" onClick={onClose} aria-label="Close status modal">
            <FaTimes />
          </button>
        </div>

        <div className="status-info">
          <div><strong>Name :</strong> {name}</div>
          <div><strong>Bill Id :</strong> {BillId}</div>
          <div><strong>Net Amt :</strong> {"-"}</div>
          <div><strong>Date :</strong> {formatDate(date)}</div>
        </div>

        <div className="status-list">
          {reportList && reportList.length > 0 ? (
            reportList.map((item, index) => (
              <div key={index} className="status-report-card">
                <div><strong>Test Name :</strong> {item.TestName || item.Test || "-"}</div>
                <div><strong>Department :</strong> {item.DeptName || item.Department || "-"}</div>
                <div><strong>Sample Received :</strong> {item.Sample || "-"}</div>
                <div><strong>Lab Received :</strong> {item.LabReceive || "-"}</div>
                <div><strong>Complete :</strong> {item.Completed || "-"}</div>
                <div><strong>Approval :</strong> {item.Approval || "-"}</div>
              </div>
            ))
          ) : (
            <div className="no-reports">No report items available for this bill.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CorporateReportStatusModal;


